var getQueryParameter = function (key) {
    var paramName = key.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + paramName + '=([^&#]*)');
    var results = regex.exec(window.location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};
export default getQueryParameter;
//# sourceMappingURL=getQueryParameter.js.map